import { LogaltoLogo } from '@/components/atoms/LogaltoLogo';
import { LOGALTO_WEBSITE_URL, OAUTH_AUTHORIZE_PATH, SUPPORTED_LOCALES } from '@/lib/constants';
import type { Locale } from '@/lib/platformTypes';
import { cn } from '@/lib/utils';
import { useLocaleStore } from '@/store/locale';

type Props = { locale: Locale; showLocaleSelector?: boolean };

export function AppHeader({ locale, showLocaleSelector = true }: Props) {
	const isOAuthAuthorizeRoute = window.location.pathname === OAUTH_AUTHORIZE_PATH;
	const setLocale = useLocaleStore((state) => state.setLocale);

	return (
		<header className="flex h-[3.75rem] items-center justify-between bg-[#343a40] px-[1.875rem] text-white">
			<a
				className="flex items-center no-underline"
				href={`${LOGALTO_WEBSITE_URL}/${locale}`}
			>
				<LogaltoLogo className="h-10 w-[7.25rem] object-contain" />
			</a>
			{showLocaleSelector && (
				<nav
					className="flex items-center gap-5 sm:gap-6"
					aria-label="Language selection"
				>
					{SUPPORTED_LOCALES.map((item) => (
						<a
							className={cn(
								'text-base font-bold tracking-[.04em] text-[#c9d0d2] no-underline hover:text-primary-hover active:text-primary-active',
								item === locale && 'text-primary',
							)}
							href={
								isOAuthAuthorizeRoute
									? `${window.location.pathname}${window.location.search}`
									: `/${item}`
							}
							key={item}
							onClick={(event) => {
								if (isOAuthAuthorizeRoute) event.preventDefault();
								setLocale(item);
							}}
						>
							{item.toUpperCase()}
						</a>
					))}
				</nav>
			)}
		</header>
	);
}
